import React from "react";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/data/company";
import { IMGS, onImgError } from "@/lib/images";

export function CTABanner({ onOpenEnquiry }) {
  return (
    <section
      className="relative bg-vortex-navy text-white overflow-hidden"
      data-testid="cta-banner"
    >
      <div className="absolute inset-0">
        <img
          src={IMGS.ctaBanner}
          onError={onImgError}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-vortex-navy-deep via-vortex-navy/95 to-vortex-navy/70" />
      </div>
      <div className="absolute inset-0 grid-pattern opacity-30 pointer-events-none" />

      <div className="container-wide relative py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="section-label !text-vortex-blue !border-vortex-blue/40 mb-5">
            Talk to an Expert
          </div>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] mb-6 text-balance">
            Need power solutions for your facility?
          </h2>
          <p className="text-lg md:text-xl text-white/75 leading-relaxed max-w-2xl mb-9">
            Get free load analysis, custom sizing and same-day quotations from
            our senior power engineers.
          </p>

          <div className="flex flex-wrap gap-3">
            <Button
              onClick={onOpenEnquiry}
              className="rounded-full bg-vortex-orange hover:bg-vortex-orange-deep text-white px-7 h-12 font-semibold shadow-lg transition-all"
              data-testid="cta-banner-quote"
            >
              Get Quote
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <a
              href={`tel:${COMPANY.phone}`}
              className="inline-flex items-center gap-2 rounded-full border-2 border-white/30 hover:bg-white hover:text-vortex-navy text-white px-7 h-12 font-semibold transition-colors"
              data-testid="cta-banner-call"
            >
              <Phone className="w-4 h-4" strokeWidth={2} />
              Call Now
            </a>
            <a
              href={`https://wa.me/${COMPANY.whatsapp}?text=Hi%20Vortex%2C%20I%20need%20a%20power%20solution.`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white px-7 h-12 font-semibold transition-colors"
              data-testid="cta-banner-whatsapp"
            >
              <MessageCircle className="w-4 h-4" strokeWidth={2} />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
